'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'window-frame';
var width = 448;
var height = 512;
var aliases = [129695];
var unicode = 'e04f';
var svgPathData = 'M352 0c35.3 0 64 28.7 64 64l0 416 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-416C32 28.7 60.7 0 96 0L352 0zM64 240l144 0 0-208-112 0C78.3 32 64 46.3 64 64l0 176zm0 32l0 208 144 0 0-208-144 0zm176 0l0 208 144 0 0-208-144 0zm144-32l0-176c0-17.7-14.3-32-32-32l-112 0 0 208 144 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWindowFrame = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;